import { Component, EventEmitter, Input, Output } from '@angular/core';
import { uuid } from '@core/helpers';
import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { SelectDropdownComponent } from 'src/app/project/components/input/select/select-dropdown/select-dropdown.component';
import { TSelectDropdownData } from 'src/app/project/components/input/select/select-dropdown/select-dropdown.model';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { EEditReminderOptions } from './point-reminder-modal-edit-reminder-button-consts';

@Component({
    selector: 'pp-point-reminder-modal-edit-reminder-button',
    templateUrl: './point-reminder-modal-edit-reminder-button.component.html',
    styleUrl: './point-reminder-modal-edit-reminder-button.component.scss',
    standalone: false
})
export class PointReminderModalEditReminderButtonComponent {
  @Output() ppEditReminder = new EventEmitter<EEditReminderOptions>();
  @Input() ppIsSeries: boolean;

  private options: TSelectOption[] = [
    {
      value: EEditReminderOptions.SINGLE,
      label: this.translationPipe.transform('edit_single_reminder'),
    },
    {
      value: EEditReminderOptions.SERIES,
      label: this.translationPipe.transform('edit_reminder_series'),
    },
  ];

  buttonId = uuid();
  EIconPath = EIconPath;
  dropdown = this.dropdownService.getDropdown();

  constructor(
    private dropdownService: DropdownService,
    private translationPipe: TranslationPipe,
  ) {}

  toggleEdit(): void {
    if (this.ppIsSeries) {
      this.showOptionsDropdown();
    } else {
      this.editReminder();
    }
  }

  editReminder(): void {
    this.ppEditReminder.emit(EEditReminderOptions.SINGLE);
  }

  showOptionsDropdown(): void {
    this.dropdownService.setData<TSelectDropdownData>({
      noSearchBar: true,
      items: this.options,
      selectedItem: null,
      width: '197px',
    });

    this.dropdownService.showDropdown(this.buttonId, SelectDropdownComponent, {
      callback: (option: TSelectOption) =>
        this.ppEditReminder.emit(option.value as EEditReminderOptions),
      popper: {
        positionFixed: true,
        placement: 'bottom-start',
      },
      width: '197px',
      suppressScrollbar: true,
    });
  }
}
